import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Comment } from '../../../api/models/comment';
import { CommentsAdapterService } from '../comments-adapter.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FilesModalComponent } from '../files-modal/files-modal.component';
import { ToastrService } from 'ngx-toastr';
import { ProjectService } from '../../../api/services/project.services';
import { WorksheetCommentsRequest } from '../../../api/models/bom-line';
import { AuthService } from '../../../api/services/auth.service';
import { ConfirmationModalComponent } from '../../confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'app-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.scss']
})
export class CommentComponent implements OnInit {

  @Input() comment: Comment;
  @Input() level: number;
  isReplying = false;

  replyBody: string = '';
  isInternal = false;
  fileIds: string[];
  fileIdsCount: Number=0;

  editMode: boolean = false;
  editedBody: string = '';
  @Output() commentEdited = new EventEmitter<Comment>();
  @Output() commentDeleted = new EventEmitter<Comment>();

  constructor(private commentsAdapterService: CommentsAdapterService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private projectService: ProjectService,
    private authservice: AuthService
  ) { }

  createReply() {
    if (!this.replyBody.trim() && (!this.fileIds || this.fileIds.length === 0)) {
      this.showWarningMsg('Please provide reply comment text or attach a file.');
    } else {
      this.commentsAdapterService.createComment(this.replyBody, this.isInternal, this.comment.id, this.fileIds)
      .subscribe(comment => {
        comment.canEditOrDelete = true;
        this.projectService.sendWSCommentNotification(this.getWSCommentObject(comment)).subscribe();
        if (this.comment.comments) {
          this.comment.comments.push(comment);
        } else {
          this.comment.comments = [comment];
        }
        this.showSucessMessage("Comment Added successfully !!");
        this.isReplying = false;
        this.replyBody = '';
        this.isInternal = false;
      });
    }
  }

  cancelComment() {
    this.isReplying = false;
    this.replyBody = '';
    this.fileIds = [];
    this.fileIdsCount = 0;
  }

  openFilesModal(type: string) {
    if (type === 'Add') {
      const modalRef = this.modalService.open(FilesModalComponent, {
        backdrop: 'static',
        keyboard: false
      });
      modalRef.componentInstance.type = type;

      modalRef.result.then(result => {
        this.fileIds = result;
        this.fileIdsCount = this.fileIds.length;
      }).catch(() => { });
    } else if (type === 'View') {
      const modalRef = this.modalService.open(FilesModalComponent, {
        backdrop: 'static',
        keyboard: false
      });
      modalRef.componentInstance.filesAttached = this.comment.fileIds;
      modalRef.componentInstance.type = type;

      modalRef.result.then(() => {
      }).catch(() => { });
    }
  }

  private showWarningMsg(msg: string){
    this.toastr.warning(msg, 'Warning!', {
      timeOut: 2000,
      positionClass: 'toast-bottom-right'
    });
  }

  private showSucessMessage(message?: string) {
    this.toastr.success(message, 'Succcess!', {
      timeOut: 4000,
      positionClass: 'toast-bottom-right'
    });
  }


  getWSCommentObject(comment: Comment): WorksheetCommentsRequest {
    let wsCompRequest = new WorksheetCommentsRequest();
    wsCompRequest.fileId = comment.fileIds ? comment.fileIds[0]: null;
    wsCompRequest.bomId = comment.universalObjectString.split('~')[1];
    wsCompRequest.commentUserId = comment.commenterUserId;
    wsCompRequest.comments = comment.body;
    return wsCompRequest;
  }


  onEdit() {
    this.editMode = true;
    this.editedBody = this.comment.body;
  }
  
  onCancelEdit() {
    console.log("inside onCancelEdit");
    this.editMode = false;
  }
  
  onSaveEdit() {
    if (this.editedBody.trim() || this.fileIds) {
      this.comment.body = this.editedBody.trim();
      this.comment.fileIds = this.fileIds;
      this.editMode = false;
      this.comment.updatedBy = this.authservice.getUserId();
      this.commentEdited.emit(this.comment);
    }else{
      this.showWarningMsg("Please provide comment text or attach a file.")
    }
  }

  onDelete() {
    const modalRef = this.modalService.open(ConfirmationModalComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.headerMsg = "Delete This Comment ?";
    modalRef.componentInstance.bodyMsg = `Are you sure you want to delete the comment "<strong>${this.comment.body}</strong>" ?`;
    modalRef.componentInstance.primaryButtonText = "Yes, Proceed";
    modalRef.componentInstance.fn = () => {
      this.commentDeleted.emit(this.comment)
      modalRef.close();
    };
  }

  removeImage() {
    const modalRef = this.modalService.open(ConfirmationModalComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.headerMsg = "Remove the Image ?";
    modalRef.componentInstance.bodyMsg = `Are you sure you want to remove the attached image ?`;
    modalRef.componentInstance.primaryButtonText = "Yes, Proceed";
    modalRef.componentInstance.fn = () => {
      this.comment.fileIds = [];
      this.fileIds = [];
      this.fileIdsCount = 0;
      modalRef.close();
    };
  }

  ngOnInit() {}

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/comments/comment/comment.component.ts